var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-share-2",
    "data-name": "Icon feather-share-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.912,
    height: 21.94,
    viewBox: "0 0 19.912 21.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M25.621,2.25A3.871,3.871,0,1,1,21.75,6.121,3.875,3.875,0,0,1,25.621,2.25Zm0,6.085a2.215,2.215,0,1,0-2.215-2.215A2.217,2.217,0,0,0,25.621,8.335Z",
    transform: "translate(-9.58 -2.25)",
    fill: "#40eefe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M7.621,12.75A3.871,3.871,0,1,1,3.75,16.621,3.875,3.875,0,0,1,7.621,12.75Zm0,6.085a2.215,2.215,0,1,0-2.215-2.215A2.217,2.217,0,0,0,7.621,18.835Z",
    transform: "translate(-3.75 -5.651)",
    fill: "#40eefe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M25.621,23.25a3.871,3.871,0,1,1-3.871,3.871A3.875,3.875,0,0,1,25.621,23.25Zm0,6.085a2.215,2.215,0,1,0-2.215-2.215A2.217,2.217,0,0,0,25.621,29.335Z",
    transform: "translate(-9.58 -9.051)",
    fill: "#40eefe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M19.889,25.208a.824.824,0,0,1-.416-.113l-6.927-4.036a.828.828,0,0,1,.834-1.431l6.927,4.036a.828.828,0,0,1-.418,1.544Z",
    transform: "translate(-6.466 -7.842)",
    fill: "#40eefe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M12.964,14.708a.828.828,0,0,1-.418-1.543l6.917-4.036a.828.828,0,0,1,.835,1.43L13.38,14.595A.824.824,0,0,1,12.964,14.708Z",
    transform: "translate(-6.466 -4.441)",
    fill: "#40eefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostShare);
export default __webpack_public_path__ + "static/media/post-share.3a51362b2c4a1820de6246ae23ee9b82.svg";
export { ForwardRef as ReactComponent };